const pages = { '/': 'Index', '/cookiepolicy': 'CookiePolicy', '/privacy-policy': 'PrivacyPolicy', '/terms': 'Terms' };
module.exports = path => pages[path.toLowerCase().replace(/\/$/, '') || '/'] || null;
